import React from "react";
import { Col, Row } from "antd";
import styled from "styled-components";

// constants messages
const CAMPAIGN_SEARCH_TEXT = ` Campaign Search Filters allow you to refine your search and save search settings for recurring use. With this feature, you can easily exclude irrelevant content, search for specific keywords, and more.`;
const ADVANCE_SEARCH_FILTER_TEXT = `Advanced Search Filters allow you to refine your search and find exactly what you're looking for. With this feature, you can easily exclude irrelevant content, search for specific keywords, and more. With Advanced Search Filters, you can refine your search and find exactly what you're looking for. This feature saves you time and helps you focus on the content that's most relevant to you.`;

type AdvancedSearchInfoProps = {
  inCampaignSmartSourced?: boolean;
};

const AdvancedSearchInfo = function AdvancedSearchInfo(props: AdvancedSearchInfoProps) {
  const { inCampaignSmartSourced } = props;

  const imageSrc = inCampaignSmartSourced ?
    "https://s3.us-west-2.amazonaws.com/media.xiqonline.com/workBench/images/campaignSearchExample.png"
    : "https://s3.us-west-2.amazonaws.com/media.xiqonline.com/workBench/images/advancedSearchExampleSVG.svg";

  return (
    <Wrapper>
      <div className="header-part">
        {/* in future the text 'Advanced search' will be changed to 'Campaign Search' */}
        <h4 className="title-tag">{inCampaignSmartSourced ? "Advanced Search" : "Advance Search Filters"}</h4>
        {/* in future the the text should be replaced with CAMPAIGN_SEARCH_TEXT */}
        <p className="dec-tag">{inCampaignSmartSourced ? ADVANCE_SEARCH_FILTER_TEXT : ADVANCE_SEARCH_FILTER_TEXT}</p>
      </div>
      <Row>
        <Col span={16}>
          {inCampaignSmartSourced ? (
            <>
              <h4 className="title-tag-sub">Keywords to Include</h4>
              <p className="dec-tag-sub">
                With Keywords to Include, you can search for content that contains specific words or phrases.For
                example, if you're interested in B2B marketing, you can enter the keyword "B2B marketing" to find
                content that contains that phrase. Similarly, you can enter "Account Based Marketing" to find content
                related to that topic.
              </p>
            </>
          ) : null}
          <h4 className="title-tag-sub">Keywords to Exclude </h4>
          <p className="dec-tag-sub">
            With Keywords to Exclude, you can exclude content that contains certain words or phrases.For example,
            if you're looking for information on B2B marketing, but you want to exclude any content that mentions
            "social media," you can enter "social media" as a keyword to exclude.
          </p>
          <h4 className="title-tag-sub">Source Content From </h4>
          <p className="dec-tag-sub">
            With Source Content From, you can specify the source of the content you're searching for. For example,
            if you're looking for articles about business on Forbes.com, you can enter "forbes.com" as the source
            of the content.You can also use top - level domains Top Level Domains(TLDs) like.in, .eu, .org, etc.,
            to refine your search further.
          </p>
          <h4 className="title-tag-sub">Exclude Content From </h4>
          <p className="dec-tag-sub">
            With Exclude Content From, you can exclude content from specific websites or domains.For example, if
            you're looking for information on a product sold on Amazon.com, but you want to exclude any results
            from Amazon.com, you can enter "amazon.com" as the domain to exclude. Similarly, you can use Top Level
            Domains(TLDs) to exclude entire groups of websites or domains.
          </p>
        </Col>
        <Col span={8}>
          <img src={imageSrc} alt="imageSrc" className="placeholder-img" />
        </Col>
      </Row>
    </Wrapper>
  );
};

export default AdvancedSearchInfo;

const Wrapper = styled.div`
  .header-part {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #E3DFE9;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding-bottom: 14px;
      margin-bottom: 14px;
    }
  .title-tag {
    font-family: "Roboto Slab", serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    letter-spacing: -0.7px;
    color: #424B50;
    margin-bottom: 5px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 18px;
      line-height: 20px;
    }
  }
  .dec-tag {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.7px;
    color: #424B50;
    margin-bottom: 5px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
      line-height: 18px;
    }
  }
 } 
 .title-tag-sub {
    font-family: "Roboto Slab", serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.7px;
    color: #424b50;
    margin-bottom: 5px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
      line-height: 16px;
    }
  }
  .dec-tag-sub {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.7px;
    color: #7E7E7E;
    margin-bottom: 15px; 
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      line-height: 16px;
    }
  }  
  .placeholder-img {
    width: 290px;
    height: auto;
    margin-left: 20px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
     width: 230px;
    }
  }
`;
